import { render, staticRenderFns } from "./article_table.vue?vue&type=template&id=295e0ec8&scoped=true"
import script from "./article_table.vue?vue&type=script&lang=ts"
export * from "./article_table.vue?vue&type=script&lang=ts"
import style0 from "./article_table.vue?vue&type=style&index=0&id=295e0ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e0ec8",
  null
  
)

export default component.exports